import { render } from "./AccountsView.vue?vue&type=template&id=0097ebc7"
import script from "./AccountsView.vue?vue&type=script&lang=js"
export * from "./AccountsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__